export const CARD_WIDTH = 300;
export const IMG_ASPECT_RATIO = '16/9';
